import React from "react";
import BannerImagesPage from "../../../features/admin/banner-images/banner-images-page";

export default function BannerImages() {
  return <BannerImagesPage />;
}
